import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  clearLocalStorage,
  getTokenFromLocalStorage,
  getUserFromLocalStorage,
  setTokenInLocalStorage,
  setUserInLocalStorage,
  setCampaignIdInLocalStorage,
} from 'utils/localStorageUtils';

interface UserState {
  user?: User | null;
  token?: string | null;
  campaign_id?: number | null;
}

interface Role {
  id: number;
  name: string;
  __entity: string;
}

interface Status {
  id: number;
  name: string;
  __entity: string;
}

export interface User {
  id: number;
  email: string;
  provider: string;
  socialId: string | null;
  firstName: string;
  lastName: string;
  role: Role;
  status: Status;
  advertiser_id: number | null;
  campaign_id: number | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

const initialState: UserState = {
  user: getUserFromLocalStorage(),
  token: getTokenFromLocalStorage(),
  campaign_id: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
      state.campaign_id = action.payload.campaign_id;
      setUserInLocalStorage(action.payload);
      setCampaignIdInLocalStorage(action.payload.campaign_id);
    },
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
      setTokenInLocalStorage(action.payload);
    },
    clearUser(state) {
      state.user = null;
      state.token = null;
      state.campaign_id = null;
      clearLocalStorage();
    },
  },
});

export const { setUser, setToken, clearUser } = userSlice.actions;
export default userSlice.reducer;
